<template>
    <div class="car-detail">
        <div class="all-content">
            <div class="car-detail-tab" @scroll="handleScroll">
                <van-row>
                    <van-col span="8">
                        <div @click="tabChecked(0)" :class="{'active':tab[0]}">
                            <p>
                                <span></span>
                            </p>
                            <span>外观</span>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div @click="tabChecked(1)" :class="{'active':tab[1]}">
                            <p>
                                <span></span>
                            </p>
                            <span>内饰</span>
                        </div>
                    </van-col>
                    <van-col span="8">
                        <div @click="tabChecked(2)" :class="{'active':tab[2]}">
                            <p>
                                <span></span>
                            </p>
                            <span>配置</span>
                        </div>
                    </van-col>
                </van-row>
            </div>
            <div class="car-detail-content">
            <van-row>
                <van-swipe v-if="slide_images.length > 0">
                    <van-swipe-item v-for="(item, index) in slide_images" :key="index">
                        <img
                            class="item banner"
                            @click="previewImg(1)"
                            :src="item"
                            :style="carDetailBanner"
                            @error="banDefault()"
                        />
                    </van-swipe-item>
                </van-swipe>

                <van-col span="24" class="car-detail-msg">
                    <p class="name">{{carInfo.name}}</p>
                    <span class="price">指导价{{result}}万</span>
                    <p class="discountPrice">
                        享补贴参考价
                        <span>{{result_2}}</span>万
                    </p>
                    <div v-show="this.from == 1" class="car-detail-share" @click="toShare()">
                        <p>
                            <img src="../../assets/car/shareThisCar.png" />
                        </p>
                        <p>分享</p>
                    </div>
                    <img v-show="this.from != 1 && !maskShow" @click="showMask" class="car-detail-share registerImg" src="../../assets/car/carRegister.png">
                </van-col>

                <van-col span="24" class="empty" id="appearance">
                    <p></p>
                </van-col>

                <van-col span="24" class="title">
                    <img src="../../assets/car/border.png" />外观
                </van-col>
                <van-col span="12" class="carImgs" v-for="(item, index) in exterior_images" :key="index">
                    <img @click="previewImg(2)" :src="item" :style="carImg" @error="defaultPro()" />
                </van-col>

                <van-col span="24" class="empty" id="InteriorTrim">
                    <p></p>
                </van-col>

                <van-col span="24" class="title">
                    <img src="../../assets/car/border.png" />内饰
                </van-col>
                <van-col span="12" class="carImgs" v-for="(item, index) in interior_images" :key="index">
                    <img @click="previewImg(3)" :src="item" :style="carImg" @error="defaultPro()" />
                </van-col>

                <van-col span="24" class="empty" id="configure">
                    <p></p>
                </van-col>

                <van-col span="24" class="title last">
                    <img src="../../assets/car/border.png" />配置
                </van-col>
            </van-row>
            <van-row class="configure" v-for="(item, index) in carInfo.params" :key="index">
                <van-col span="16" class="list left">{{item.name}}</van-col>
                <van-col span="8" class="list right">{{item.value}}</van-col>
            </van-row>
            <van-image-preview v-model="show" :images="images" @change="onChange">
                <template v-slot:index>第{{ index+1 }}页</template>
            </van-image-preview>
            </div>
        </div>
        <!-- <div class="weixin-tip" v-if="maskShow">
			<p>
				<img  v-if="!isIOS" src="../../assets/common/live_weixin.png" alt="微信打开"/>
				<img  v-if="isIOS" src="../../assets/common/live_weixin_ios.png" alt="微信打开"/>
			</p>
		</div> -->
        <div class="mask-bg" v-if="maskShow && this.from != 1">
            <div class="mask-box" :style="boxHeight">
                <register @maskHide="hideNask" />
            </div>
        </div>
    </div>
</template>

<script>
import defaultImg from "@/assets/common/ListPreload.png";
import productDefault from "@/assets/common/preload.png";
import register from './register.vue';
export default {
	components: {
		register
	},
    data() {
        return {
            show: false,
            index: 0,
            images: [],
            carDetailBanner: {
                height: document.body.clientWidth * 0.55 + "px"
                //	      'white-space': 'normal'
            },
            carImg: {
                height: ((document.body.clientWidth - 48) / 2) * 0.75 + "px"
            },
            carInfo: {},
            result: "",
            result_2: "",
            slide_images: [],
            exterior_images: [],
            interior_images: [],
            tab: [1, 0, 0],
            offsetTop1: "",
            offsetTop2: "",
            offsetTop3: "",
            from: "", //from=1代表从app进入否则从网页进入
            parmSrc: '',
            isWeixin: false,
			isIOS: false,
			isQQ: false,
            maskShow: true,
            boxHeight: {height: '473px'}
        };
    },
    created() {
//      this.$api.setToken(this.$route.query.token);
		this.$api.setToken();
//		localStorage.removeItem('_token');
        this.from = this.$route.query.from;

        var u = navigator.userAgent;
		this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
		this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		// this.isQQ = ua.indexOf(' qq')>-1 && ua.indexOf('mqqbrowser') <0;
		if(u.toLowerCase().indexOf('qq')>-1 && u.toLowerCase().indexOf('mqqbrowser') <0 && this.isIOS){
            //qq内置浏览器
            this.isQQ = true;
		}
    },
    mounted() {//car-detail-content
        this.getInfo();
        document.querySelector(".car-detail-content").addEventListener("scroll", this.handleScroll);
        
    },
    updated() {
        this.offsetTop1 = document.querySelector("#appearance").offsetTop - 30;
        this.offsetTop2 = document.querySelector("#InteriorTrim").offsetTop - 30;
        this.offsetTop3 = document.querySelector("#configure").offsetTop - 30;
    },
    methods: {
        onChange(index) {
            this.index = index;
        },
        previewImg(newImg) {
            if (newImg == 1) {
                this.images = this.slide_images;
            } else if (newImg == 2) {
                this.images = this.exterior_images;
            } else if (newImg == 3) {
                this.images = this.interior_images;
            }
            this.show = true;
        },
        getInfo() {
            var ID = this.$route.query.id;
            this.$api
                .get("/car/index/car-model/detail", { id: ID })
                .then(res => {
                    res.name = res.name.replace(/[ ]/g, "");
                    this.carInfo = res;
                    this.result = (
                        Math.ceil(Number(res.price) / 100) / 100
                    ).toFixed(2);
                    this.result_2 = (
                        Math.ceil(Number(res.price) / 200) / 100
                    ).toFixed(2);
                    this.slide_images = res.slide_images || [];
                    this.exterior_images = res.exterior_images || [];
                    this.interior_images = res.interior_images || [];
                    //		        this.exterior_images[1] = this.exterior_images[0]

                    //car_id、short_title、image_url、long_title
                    if(this.isIOS) {
                        this.parmSrc = 'car/car_detail?carId='+ID+'&short_title='+res.name+'&image='+res.image+'&name='+res.name;
                    }else {
                        this.parmSrc = 'car/car_detail?car_id='+ID+'&short_title='+res.name+'&image_url='+res.image;
                    }
                    
                });
        },
        banDefault() {
            var img = event.srcElement;
            img.src = defaultImg;
            img.onerror = null; //防止闪图
        },
        defaultPro() {
            var img = event.srcElement;
            img.src = productDefault;
            img.onerror = null; //防止闪图
        },
        toShare() {
            // 分享
            var title =
                "指导价" +
                this.result +
                "万，补贴约" +
                this.result_2 +
                "万\n" +
                this.carInfo.name;
            var bigTitle = "【销巴汽车】200多个品牌8000多款车型，购车即享补贴！";
            var thumb = this.slide_images[0];
            let url =
                location.href.split("?")[0] + "?id=" + this.$route.query.id;
            var result = [bigTitle, title, url, thumb];
            this.params(result, JSON.stringify(result), "toShare");
            // if (this.from == 1) {}else if(this.isWeixin || this.isQQ) {
            //     this.maskShow = true;
            // } else {
            //     // 打开app
            //     this.open_app();
            // }
        },
        // open_app() {
        //     if(this.$route.query.shareCode) {
        //         let par = 'shareCode='+this.$route.query.shareCode+'&mobile='+this.$route.query.mobile;
        //         this.openApp('register',par, this.parmSrc);
        //     }else {
        //         this.openApp('', '', this.parmSrc);
        //     }
        // },
        /*compare() {
	    	this.params('', '','compare');
        },*/
        showMask() {
            this.maskShow = true;
        },
        hideNask() {
            this.maskShow = false;
        },
        tabChecked(a1) {
            this.tab = [0, 0, 0];
            this.tab[a1] = 1;
            if (a1 == 0) {
                document.querySelector(".car-detail-content").scrollTop = this.offsetTop1;
//              document.documentElement.scrollTop = this.offsetTop1;
            } else if (a1 == 1) {
                document.querySelector(".car-detail-content").scrollTop = this.offsetTop2;
//              document.documentElement.scrollTop = this.offsetTop2;
            } else if (a1 == 2) {
                document.querySelector(".car-detail-content").scrollTop = this.offsetTop3;
//              document.documentElement.scrollTop = this.offsetTop3;
            }
        },
        handleScroll() {
            var scrollTop = document.querySelector(".car-detail-content").scrollTop;
            if (scrollTop < this.offsetTop2) {
                this.tab = [1, 0, 0];
            } else if (
                scrollTop >= this.offsetTop2 &&
                scrollTop < this.offsetTop3
            ) {
                this.tab = [0, 1, 0];
            } else if (scrollTop >= this.offsetTop3) {
                this.tab = [0, 0, 1];
            }
        }
    },
    destroyed() {
        document.querySelector(".car-detail-content").removeEventListener("scroll", this.handleScroll);
    }
};
</script>

<style lang="less">
.car-detail {
    height: 100%;
    background: #fff;
    color: #555;
    .car-detail-tab {
        height: 40px;
        line-height: 38px;
        font-size: 15px;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        background: #fff;
        z-index: 10;
        .van-row {
            padding: 0 64px;
            height: 40px;
            .van-col {
                text-align: center;
                position: relative;
                height: 40px;
                div {
                    font-size: 15px;
                    color: #adb2b8;
                }
                p {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    text-align: center;
                    width: 100%;
                    height: 4px;
                    line-height: 4px;
                    margin: 0;
                }
            }
            .active {
                span {
                    color: #333;
                    font-weight: bold;
                }
                p {
                    span {
                        width: 30px;
                        height: 2px;
                        display: inline-block;
                        background: #1d5ef2;
                        vertical-align: middle;
                        margin-bottom: 1px;
                    }
                }
            }
        }
    }
    .car-detail-content {
        padding-top: 40px;
        box-sizing: border-box;
        height: 100%;
        width: 100%;
        overflow-x: hidden;
        overflow-y: scroll;
        -webkit-overflow-scrolling:touch;
        .van-swipe {
            .banner {
                width: 100%;
                display: block;
                background: #f2f2f2;
            }
            .van-swipe__indicator:not(:last-child) {
                margin-right: 4px;
            }
            .van-swipe__indicator {
                width: 4px;
                height: 3px;
                border-radius: 0;
                background: rgba(255, 255, 255, 0.3);
            }
            .van-swipe__indicator--active {
                width: 11px;
                height: 3px;
                border-radius: 0;
                background: rgba(255, 255, 255, 1);
            }
        }

        .car-detail-msg {
            padding: 11px 16px 0;
            position: relative;
            p {
                margin: 0;
            }
            .name {
                color: #333;
                font-size: 18px;
                line-height: 35px;
            }
	        @media screen and (max-width: 320px) {
				.name {
	            	font-size: 16px;
	            }
			}
            .price {
                color: #adb2b8;
                font-size: 12px;
                background: #f5f6f7;
                border-radius: 3px;
                height: 24px;
                line-height: 24px;
                margin: 6px 0;
                display: inline-block;
                padding: 0 8px;
            }
            .discountPrice {
                color: #f2301d;
                font-size: 12px;
                height: 30px;
                line-height: 33px;
                span {
                    font-size: 22px;
                }
            }
            .car-detail-share {
                position: absolute;
                right: 16px;
                bottom: 0;
                width: 54px;
                height: 54px;
                color: #666;
                font-size: 12px;
                text-align: center;
                border-radius: 4px;
                border: solid 1px #eee;
                p {
                    height: 27px;
                    line-height: 25px;
                    img {
                        width: 21px;
                        display: inline-block;
                        margin-top: 7px;
                    }
                }
            }
            .registerImg {
                position: fixed;
                top: 43.6%;
                right: 0;
                border: none;
                width: 96px;
                height: 85px;
            }
        }
        .empty {
            height: 40px;
            p {
                height: 8px;
                background: #f5f6f7;
                margin: 16px 0;
            }
        }
        .title {
            color: #333;
            font-size: 18px;
            height: 22px;
            line-height: 22px;
            img {
                width: 4px;
                float: left;
                margin: 0 9px 0 16px;
            }
        }
        @media screen and (max-width: 320px) {
			.title {
            	font-size: 16px;
            }
		}
        .last {
            margin-bottom: 17px;
        }
        .carImgs {
            padding: 16px 8px 0 16px;
            img {
                display: block;
                width: 100%;
                background: #d8d8d8;
                border-radius: 4px;
            }
        }
        .carImgs:nth-child(2n) {
            padding: 16px 16px 0 8px;
        }
        .top {
            padding-top: 13px;
        }
	    .configure {
	        padding-top: 0;
	        margin-bottom: 20px;
	        .list {
	            padding-right: 16px;
	            height: auto;
	            line-height: 22px;
	            text-align: right;
	            color: #777;
	            color: #555;
	            font-size: 16px;
	        }
	        .left {
	        	padding-right: 6px;
	            padding-left: 16px;
	            text-align: left;
	        }
	        @media screen and (max-width: 320px) {
				.list {
	            	font-size: 13px;
	            }
			}
	    }
	    .compare {
	        width: 56px;
	        height: 56px;
	        border-radius: 28px;
	        box-shadow: rgba(153, 153, 153, 0.3) 2px 0 8px;
	        text-align: center;
	        position: fixed;
	        right: 16px;
	        bottom: 16px;
	        z-index: 8;
	        background: #fff;
	        img {
	            width: 34px;
	            margin-top: 19px;
	            display: inline-block;
	        }
	    }
    }
	.weixin-tip {
		position: fixed;
		left: 0;
		top: 0;
		z-index: 10;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, .7);
		p {
			padding: 15px 25px;
			img {
				width: 100%;
				display: block;
			}
		}
    }
    .mask-bg {
        position: fixed;
		left: 0;
		top: 0;
        z-index: 10;
        width: 100%;
		height: 100%;
        padding: 0 27px;
        background: rgba(0, 0, 0, .5);
        box-sizing: border-box;
        .mask-box {
            width: 100%;
            // height: auto;
            // max-height: 50%;
            overflow-y: scroll;
            padding: 0 27px;
            box-sizing: border-box;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
        }
    }
}
</style>
